import React, { useEffect, useRef, useState, useContext } from "react";
import { ScrollContext } from "../../../context/ScrollContext";
import useGoBack from "../../../hooks/useGoBack";
import BackChevronWithTitle from "../../BackChevronWithTitle/BackChevronWithTitle";
import styles from "./LegalAndPrivacyContainer.module.scss";
type contianerProps = {
  title: string;
  children?: React.ReactNode;
};
const LegalAndPrivacyContainer: React.FC<contianerProps> = ({ title, children }) => {
  const { handleScroll } = useContext(ScrollContext);
  const [isLoading, setIsLoading] = useState(false);
  const myRef = useRef<HTMLDivElement>(null);
  const { onClickBack } = useGoBack();
  useEffect(() => {
    setIsLoading(true);
    if (myRef.current) {
      window.scrollTo({
        behavior: "smooth",
        top: 0,
      });
    }
    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  return (
    <div className={styles.parent}>
      <BackChevronWithTitle text={title} onClick={onClickBack} />
      <div className={styles.container} ref={myRef} onScroll={handleScroll}>
        {children}
      </div>
    </div>
  );
};
export default LegalAndPrivacyContainer;
